import React from 'react';
import {ReactComponent as MHLogo} from './../assets/colorLogo.svg'

export default class Logo extends React.Component {
    render() {
      return <MHLogo className="logo home-leading-space"/>
    }
  }